let Status = class Status {
    has(provider) {
        return provider.prototype.constructor.name === this.provider.constructor.name;
    }
    getProvider() {
        return this.provider;
    }
    setProvider(provider) {
        this.provider = provider;
    }
    isStatus() {
        return this.status;
    }
    setStatus(status) {
        this.status = status;
    }
    getMessage() {
        return this.message;
    }
    setMessage(message) {
        this.message = message;
    }
    constructor(provider, status, message = ''){
        this.provider = provider;
        this.status = status;
        this.message = message;
    }
};

export { Status as default };
